// extracted by mini-css-extract-plugin
export var closeButton = "_fa-1";
export var closeX = "_fa-3";
export var container = "_fa-0";
export var image = "_fa-2";